import moment from 'moment';
import * as types from '../actions/action-types';

const INITIAL_STATE = {
    viewportWidth: null,
    navActive: false,
    onSiteAddDates: [],
    promoItems: [],
    lineItems: [],
    expandNav: false,
    modalReporting: false,
    modalGenerateReporting: false,
    reportingLastAccess: moment(),
    sessionModal: false
};

export const getSessionModal = state => state.sessionModal;

export default (state = INITIAL_STATE, action) => {
    if (action.type === types.TOGGLE_MOBILE_NAV) {
        return {
            ...state,
            navActive: !state.navActive
        };
    } else if (action.type === types.TOGGLE_EXPAND_NAV) {
        return {
            ...state,
            expandNav: !state.expandNav
        };
    } else if (action.type === types.CLOSE_NAV) {
        return {
            ...state,
            navActive: false
        };
    } else if (action.type === types.RESIZE) {
        return {
            ...state,
            viewportWidth: action.width
        };
    } else if (action.type === types.ADD_ON_SITE_DATE) {
        return {
            ...state,
            onSiteAddDates: [...state.onSiteAddDates, action.onSiteAddDates]
        };
    } else if (action.type === types.DELETE_ON_SITE_DATE) {
        return {
            ...state,
            onSiteAddDates: state.onSiteAddDates.filter(
                item => item.id !== action.onSiteAddDates
            )
        };
    } else if (action.type === types.ADD_PROMO_ITEMS) {
        return {
            ...state,
            promoItems: [...state.promoItems, action.promoItems]
        };
    } else if (action.type === types.DELETE_PROMO_ITEMS) {
        return {
            ...state,
            promoItems: state.promoItems.filter(
                item => item.id !== action.promoItems
            )
        };
    } else if (action.type === types.ADD_LINE_ITEMS) {
        return {
            ...state,
            lineItems: [...state.lineItems, action.lineItems]
        };
    } else if (action.type === types.DELETE_LINE_ITEMS) {
        return {
            ...state,
            lineItems: state.lineItems.filter(
                item => item.id !== action.lineItems
            )
        };
    } else if (action.type === types.TOGGLE_MODAL_REPORTING) {
        return {
            ...state,
            modalReporting: !state.modalReporting
        };
    } else if (action.type === types.TOGGLE_MODAL_GENERATE_REPORTING) {
        return {
            ...state,
            modalGenerateReporting: !state.modalGenerateReporting
        };
    } else if (action.type === types.SET_ONSITE_DATES) {
        return {
            ...state,
            onSiteAddDates: action.dates
        };
    } else if (action.type === types.SESSION_MODAL) {
        return {
            ...state,
            sessionModal: !state.sessionModal
        };
    }
    return state;
};



// WEBPACK FOOTER //
// ./src/reducers/ui.js